import { capitalizeText, formatDate, toCurrencyFormat } from '@jagad/utils'
import PaymentLinkTransactionStatusIcon from '../PaymentLinkTransactionStatusIcon/PaymentLinkTransactionStatusIcon'
import type { PaymentLinkStatus } from '../PaymentLinkTransactionStatusIcon/PaymentLinkTransactionStatusIcon'
import {
    Container,
    Row,
    LeftColumn,
    RightColumn,
    CurrencyText,
    DateColumn,
    StatusColumn,
} from './PaymentLinkActivityListItem.styles'

export type PaymentLinkActivity = {
    uuid?: string
    status: PaymentLinkStatus
    amount: number
    timestamp: Date
    onClick?: () => void
}

export type PaymentLinkActivityListItemProps = PaymentLinkActivity & {
    quotationLabel: string
    currencyText: string
}

const PaymentLinkActivityListItem = ({
    status,
    amount,
    timestamp,
    onClick,
    quotationLabel,
    currencyText,
}: PaymentLinkActivityListItemProps) => {
    return (
        <Container onClick={onClick}>
            <Row>
                <LeftColumn>
                    <span>{quotationLabel}</span>
                </LeftColumn>
                <RightColumn>
                    <span>{toCurrencyFormat(amount)}</span>
                    <CurrencyText>{currencyText}</CurrencyText>
                </RightColumn>
            </Row>
            <Row>
                <DateColumn>
                    <span>{formatDate(timestamp)}</span>
                </DateColumn>
                <StatusColumn $status={status}>
                    <span>{capitalizeText(status)}</span>
                    <PaymentLinkTransactionStatusIcon status={status} />
                </StatusColumn>
            </Row>
        </Container>
    )
}

export default PaymentLinkActivityListItem
